import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Formik, ErrorMessage } from 'formik'
import * as yup from 'yup'

import _ from 'lodash'

import { Button, TextInput } from '../../../../../shard'
import { Color, Size } from '../../../../../../const'

import { useAccountHook } from '../../../../../../hooks'

function AccountEditUser() {
  const { history, axios, user, setUser } = useAccountHook()

  if (_.isEmpty(user)) {
    axios.getUser().then(setUser)

    return <div></div>
  } else {
    return <AccountEditUserDisplay history={history} axios={axios} user={user}></AccountEditUserDisplay>
  }
}

function AccountEditUserDisplay({ history, axios, user }) {
  return (
    <Wrapper>
      <NameBlock>
        <Formik
          initialValues={{
            lastname: user.lastname,
            firstname: user.firstname,
            lastname_kana: user.lastname_kana,
            firstname_kana: user.firstname_kana,
          }}
          onSubmit={(values, actions) => {
            axios.updateUser(values).then((data) => {
              actions.setSubmitting(false)
              history.replace('/account/edit/complete')
            })
          }}
          validationSchema={yup.object().shape({
            lastname: yup.string().required('項目が未入力です'),
            firstname: yup.string().required('項目が未入力です'),
            lastname_kana: yup.string().required('項目が未入力です'),
            firstname_kana: yup.string().required('項目が未入力です'),
          })}
        >
          {({ values, handleChange, handleBlur, handleSubmit, dirty, isSubmitting, isValid }) => (
            <form onSubmit={handleSubmit}>
              <InputLabel>氏名</InputLabel>
              <TextInput
                key="lastname"
                type="lastname"
                name="lastname"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.lastname}
                ariaLabel="lastname"
                placeholder="山田"
                errorMessage={<ErrorMessage name="lastname" />}
              />
              <TextInput
                key="firstname"
                type="firstname"
                name="firstname"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstname}
                ariaLabel="firstname"
                placeholder="太郎"
                errorMessage={<ErrorMessage name="firstname" />}
              />

              <InputLabel>フリガナ</InputLabel>
              <TextInput
                key="lastname_kana"
                type="lastname_kana"
                name="lastname_kana"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.lastname_kana}
                ariaLabel="lastname_kana"
                placeholder="ヤマダ"
                errorMessage={<ErrorMessage name="lastname_kana" />}
              />
              <TextInput
                key="firstname_kana"
                type="firstname_kana"
                name="firstname_kana"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstname_kana}
                ariaLabel="firstname_kana"
                placeholder="タロウ"
                errorMessage={<ErrorMessage name="firstname_kana" />}
              />

              <ButtonWrapper>
                <Button type={'submit'} primary disabled={!isValid || !dirty || isSubmitting}>
                  変更する
                </Button>
              </ButtonWrapper>
            </form>
          )}
        </Formik>
      </NameBlock>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding-bottom: 100px;
`
const NameBlock = styled.div`
  padding: 20px 24px 40px 24px;
  border-radius: 10px;
  border: 1px solid ${Color.LINE.NORMAL};
`

const InputLabel = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.INPUT_LABEL};
  padding-top: 29px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 60px;
`

AccountEditUser.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitLogin: PropTypes.func,
}

AccountEditUserDisplay.propTypes = {
  history: PropTypes.object,
  axios: PropTypes.object,
  user: PropTypes.array,
}

export default AccountEditUser
